import styled from "styled-components";

interface StyledDialogCaptionProps {
  $size: "large" | "medium" | "small";
  $state: "info" | "success" | "warning" | "error";
}

export const StyledDialogCaption = styled.div<StyledDialogCaptionProps>`
  display: flex;
  gap: 0.4rem;
  & > .icon {
    padding: 0.4rem;
  }
  .pre-wrap {
    white-space: pre-wrap;
    word-break: break-all;
  }
  & > p {
    font: var(--body-small-400);
    color: var(--text-gray-4);
  }
`;
